<div class="main-content">
  <div class="nav-area"><app-nav-footer></app-nav-footer></div>
  <div class="main-content-input">
    <app-header></app-header>
        <div class="kanban-board-content">
          <app-kanban-board></app-kanban-board>
        </div>
  </div>
</div>
<div class="createdTask"> <p>Task added to board </p><img src="assets/img/kanban-board/taskAddedIcon.png"></div>
<app-nav-footer-mobile></app-nav-footer-mobile>